export const getStrategyResults = (strategy, result) => {
  const {bets} = strategy.backtesting;
  return bets.filter(bet => bet.result === result).length;
};

export const formatStrategyOutcome = outcome => (outcome ? outcome.toLocaleString().replace(/,/g, "'") : 0);
